import { createStyles, lighten, makeStyles, Theme } from '@material-ui/core';

export const useToolbarStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(1),
            display: 'flex',
            justifyContent: 'flex-end',
        },
        button: {
            marginLeft: theme.spacing(1),
        },
    }),
);
